import { useLanguage } from "../contexts/LanguageContext";
import { user as userJa } from "../translations/ja/user";
import { user as userEn } from "../translations/en/user";

/**
 * 現在の言語設定に応じたユーザー情報を取得するフック
 */
export const useUserInfo = () => {
	const { language } = useLanguage();
	return language === 'ja' ? userJa : userEn;
};
